import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'antd/lib/icon';
import _isString from 'lodash/isString';
import memo from 'memoize-one';
import { IconImg } from './styles';
import { isUrl } from './utils';

const getIconProperty = memo((icon) => {
  if (_isString(icon)) {
    if (isUrl(icon)) {
      return <IconImg src={icon} alt="icon" />;
    }

    return <Icon type={icon} />;
  }

  return icon;
});

const MenuTitle = ({ name, icon }) => (
  <span>
    {getIconProperty(icon)}
    <span>{name}</span>
  </span>
);

MenuTitle.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
};

MenuTitle.defaultProps = {
  icon: null,
};

export default MenuTitle;
